import { Company } from "../../domain/model/company";
import { User } from "../../domain/model/user";
import { AuthStateType } from "../auth_state_type";

interface ICreateCustomerResponse {
  user: User;
}
class CreateCustomerResponse implements ICreateCustomerResponse {
  public user: User;
}

interface IObserveAuthListenerResponse {
  user: User;
  authState: AuthStateType;
}
class ObserveAuthListenerResponse implements IObserveAuthListenerResponse {
  public user: User;
  public company?: Company;
  public authState: AuthStateType;
}

interface IOnAuthListenerResponse {}
class OnAuthListenerResponse implements IOnAuthListenerResponse {}

interface IOffAuthListenerResponse {}
class OffAuthListenerResponse implements IOffAuthListenerResponse {}

interface ILoginResponse {}
class LoginResponse implements ILoginResponse {}

interface IGetMeResponse {
  user: User;
  company?: Company;
}
class GetMeResponse implements IGetMeResponse {
  public user: User;
  public company?: Company;
}

export {
  CreateCustomerResponse,
  ObserveAuthListenerResponse,
  OnAuthListenerResponse,
  OffAuthListenerResponse,
  LoginResponse,
  GetMeResponse,
};



// WEBPACK FOOTER //
// ./src/presentation/response/auth_response.ts